<template>
  <div>
    <div
      class="c-loading"
      :style="styles"
    >
      <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="circle" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    minHeight: {
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    styles () {
      return {
        'minHeight': this.minHeight,
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';

.c-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 240px;
  font-size: 15px;
  padding: 20px;
}

.spinner
{
  animation: rotation 1.35s linear infinite;
}

svg {
  stroke: $color-accent-primary;
}

@keyframes rotation
{
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(270deg);
  }
}

.circle
{
  stroke-dasharray: 180;
  stroke-dashoffset: 0;
  -ms-transform-origin: center;
  transform-origin: center;
  animation: turn 1.35s ease-in-out infinite;
}

@keyframes turn
{
  0% {
    stroke-dashoffset: 180;
  }

  50% {
    stroke-dashoffset: 45;
    transform: rotate(135deg);
  }

  100% {
    stroke-dashoffset: 180;
    transform: rotate(450deg);
  }
}
</style>
